import type { FaireProductEntity } from "../../entity_types/product";

export const p_em8mh2xxjn: FaireProductEntity = {
  token: "p_em8mh2xxjn",
  type: "product",
  name: "Women's Summer Floral Square Neck Puff Sleeve Babydoll Dress",
  brandToken: "b_t9mynp4xpd",
  brandName: "Lovesoft",
  imageUrl:
    "https://cdn.faire.com/fastly/0d013e6eebc0d27a165db515f5bf036f09c17b8881387af1a46f72ddad2ed12d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/168d63947371e3323b608a0d2edea9e2f43ce34e6fd3ddc9e195d896c262155b.jpeg",
    "https://cdn.faire.com/fastly/ad1d6c48938f7c8a50e85cb23f099aac1e43b88f2b6a398c601a1d81eb77191a.jpeg",
    "https://cdn.faire.com/fastly/2ddd91d503357ab6281fc28bfeae93f916036e116c92b1ea152cc6effb18bfff.jpeg",
    "https://cdn.faire.com/fastly/31538922b9a6f93221eef580b64927037a8615b5d1cf3107113df70b490d5444.jpeg",
    "https://cdn.faire.com/fastly/8ee289dc02dc10ab0698a41871248451a818f1aaf47b28f855757d29a743655d.jpeg",
    "https://cdn.faire.com/fastly/f9479d93a95cc716e35633ffa00eb89000c422902b7795026d2254f35b9a8a7c.jpeg",
    "https://cdn.faire.com/fastly/44faa1ebdfd85c9272c44ec7d8e94bd6a0ec9387357d2a26252d4e96dea49f86.jpeg",
  ],
  priceDollars: 18.94,
  description:
    " *  This floral dress is sweet and adorable for the summer times\n The square neck and puff sleeve also worthy to be love\n This babydoll dress is loose fit for most body shapes\n The low back finished greatly shows off sexy back curves\n\n* Brand labels are not included by default. If needed, please add them via this link ($0.30/pc): https://www.faire.com/product/p_kzks8vegvk",
  tags: [],
  msrpDollars: 37.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:16.382Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
